import useLocalStorageState from "use-local-storage-state";
import { Target } from "@labs/shared/types/Target.ts";

export const useLocalTargetState = () =>
  useLocalStorageState<Target>("target", {
    defaultValue: {
      goal: 42,
      baselineYear: "2020",
      targetYear: "2030",
      expectedBusinessGrowth: 5,
    },
  });
